<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="所属项目">
              <a-select
                showSearch
                optionFilterProp="children"
                placeholder="请选择所属项目"
                @change="projectChange"
                v-decorator="['projectId', { rules: [{ required: false, message: '请选择所属项目！' }] }]"
              >
                <a-select-option v-for="(item, index) in projectList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="招标人">
              <!-- <a-input
                disabled
                v-decorator="['tenderee', { rules: [{ required: false }] }]"
              /> -->
              <a-select
                disabled
                v-decorator="['tenderee', { rules: [{ required: false }] }]"
              >
                <a-select-option v-for="(item, index) in proprietorList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称">
              <a-input
                placeholder="请输入合同名称"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['name', { rules: [{ required: true, message: '请输入合同名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同编号">
              <a-input
                placeholder="请输入合同编号"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['number', { rules: [{ required: true, message: '请输入合同编号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
              <a-input
                addon-after="元"
                placeholder="请输入合同金额"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['contractAmount', { rules: [{ required: true, message: '请输入合同金额！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
              <!-- <a-input
                placeholder="请输入联系人"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['contacts', { rules: [{ required: true, message: '请输入联系人！' }] }]"
              /> -->
              <a-select
                allowClear
                placeholder="请选择联系人"
                :disabled="!isEdit"
                @change="contactChange"
                v-decorator="['contacts', { rules: [{ required: true, message: '请选择联系人！' }] }]"
              >
                <a-select-option v-for="(item, index) in contactList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号码">
              <a-input
                placeholder="请输入手机号码"
                disabled
                autoComplete="off"
                v-decorator="['mobile', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生效日期">
              <a-date-picker
                style="width: 100%"
                placeholder="请选择生效日期"
                :disabled="!isEdit"
                v-decorator="['effectiveDate', { rules: [{ required: true, message: '请选择生效日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到期日期">
              <a-date-picker
                style="width: 100%"
                placeholder="请选择到期日期"
                :disabled="!isEdit"
                v-decorator="['expirationDate', { rules: [{ required: true, message: '请选择到期日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人">
              <a-select
                placeholder="请选择经办人"
                allowClear
                showSearch
                optionFilterProp="children"
                :disabled="!isEdit"
                v-decorator="['operatorId', { rules: [{ required: true, message: '请选择经办人！' }] }]"
              >
                <a-select-option v-for="(item, index) in userList" :key="index" :value="item.id">{{ item.userName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办日期">
              <a-date-picker
                style="width: 100%"
                placeholder="请选择经办日期"
                :disabled="!isEdit"
                v-decorator="['handleDate', { rules: [{ required: true, message: '请选择经办日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预付款">
              <a-input
                addon-after="%"
                placeholder="请输入预付款"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['advanceCharge', { rules: [{ required: true, message: '请输入预付款！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到货款">
              <a-input
                addon-after="%"
                placeholder="请输入到货款"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['arrivalCharge', { rules: [{ required: true, message: '请输入到货款！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预验收款">
              <a-input
                addon-after="%"
                placeholder="请输入预验收款"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['preAcceptanceCharge', { rules: [{ required: true, message: '请输入预验收款！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="政府审计款">
              <a-input
                addon-after="%"
                placeholder="请输入政府审计款"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['governmentAuditFund', { rules: [{ required: true, message: '请输入政府审计款！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验收款">
              <a-input
                addon-after="%"
                placeholder="请输入验收款"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['acceptanceCharge', { rules: [{ required: true, message: '请输入验收款！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质保金">
              <a-input
                addon-after="%"
                placeholder="请输入质保金"
                :disabled="!isEdit"
                autoComplete="off"
                v-decorator="['warrantyGlod', { rules: [{ required: true, message: '请输入质保金！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注">
              <a-textarea
                :rows="3"
                placeholder="请输入备注"
                :disabled="!isEdit"
                v-decorator="['remark', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="上传附件">
              <file-upload
                ref="fileUpload"
                :list="fileList"
                @handleUpload="handleUpload"
              ></file-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24" style="margin-top: 10px; text-align: right">
            <a-button
              type="primary"
              html-type="submit"
              style="margin-right:10px;"
              v-if="this.type !== this.$sysInfo.MODAL_VIEW"
            >提交</a-button>
            <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import moment from 'moment'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { updateSalesContract } from '@/api/contract'
import fileUpload from '@/CrComponents/UploadC'
import { getContactsById } from '../../../../../api/contacts'
// import { addressOptions } from '@/utils/proviceData.js'
export default {
  name: 'EditProject',
  mounted () {
    // this.initArea()
  },
  computed: {
    projectList () {
      return this.$store.state.contract.projectList
    },
    proprietorList () {
      return this.$store.state.market.proprietorList
    },
    userList () {
      return this.$store.state.market.userList
    }
  },
  components: {
    baseModal,
    fileUpload
  },
  data () {
    return {
      title: '操作',
      width: 800,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'markets' }),
      visible: false,
      defaultModel: {},
      model: {},
      headers: {
        Authorization: this.$store.state.user.token
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },

      isEdit: false,

      fileList: [],
      acceptType: 'image/bmp,image/jpg,image/jpeg,image/png',

      contactList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        if (this.type === this.$sysInfo.MODAL_MODIFY) {
          this.isEdit = true
          this.setModelInfo()
        }
      }
    },
    setModelInfo () {
      if (this.model.tenderee) {
        this.initContactList(this.model.tenderee)
      }
      const model = {
        projectId: this.model.projectId,
        tenderee: this.model.tenderee,
        name: this.model.name,
        number: this.model.number,
        contractAmount: this.model.contractAmount,
        contacts: this.model.contacts,
        mobile: this.model.mobile,
        effectiveDate: moment(this.model.effectiveDate),
        expirationDate: moment(this.model.expirationDate),
        operatorId: this.model.operatorId,
        handleDate: moment(this.model.handleDate),
        advanceCharge: this.model.advanceCharge,
        arrivalCharge: this.model.arrivalCharge,
        preAcceptanceCharge: this.model.preAcceptanceCharge,
        governmentAuditFund: this.model.governmentAuditFund,
        acceptanceCharge: this.model.acceptanceCharge,
        warrantyGlod: this.model.warrantyGlod,
        remark: this.model.remark
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(model)
      })
      if (this.model.files) {
        this.fileList = this.model.files.map((item, index) => {
          return {
            uid: index,
            name: item.fileName,
            fileName: item.fileName,
            filePath: item.filePath,
            // url: item.filePath,
            status: 'done'
          }
        })
      }
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }
          params.effectiveDate = moment(params.effectiveDate).format('YYYY-MM-DD')
          params.expirationDate = moment(params.expirationDate).format('YYYY-MM-DD')
          params.handleDate = moment(params.handleDate).format('YYYY-MM-DD')
          params.files = this.fileList.map(item => {
            return {
              fileName: item.fileName,
              filePath: item.filePath
            }
          })
          if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id
          }
          updateSalesContract(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
    },
    // 清空表单
    formClear () {
      this.isEdit = false
      this.form.resetFields()
      this.contactList = []
      this.fileList = []
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    projectChange (val) {
      if (!this.isEdit) {
        this.isEdit = true
      }
      this.form.setFieldsValue({ tenderee: undefined, contacts: undefined })
      if (val) {
        this.projectList.map(item => {
          if (item.id === val) {
            this.form.setFieldsValue({ tenderee: item.proprietorId })
            this.initContactList(item.proprietorId)
          }
        })
      } else {
        this.contactList = []
      }
    },
    initContactList (proprietorId) {
      getContactsById(proprietorId).then(res => {
        if (res.status === 0) {
          this.contactList = res.data
        }
      })
    },
    contactChange (val) {
      this.form.setFieldsValue({ mobile: undefined })
      if (val) {
        this.contactList.map(item => {
          if (item.id === val) {
            this.form.setFieldsValue({ mobile: item.phone1 })
          }
        })
      }
    },
    handleUpload (fileList) {
      console.log('data', fileList)
      this.fileList = fileList
    }
  }
}
</script>

<style scoped lang="less">
.downloadList {
  margin-top: 10px;
  list-style: none;
  li {
    margin: 10px;
  }
}
</style>
